import type { TriggerEvent } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/events';
import type { DateRangeFns } from '@cobliteam/common-types';
import { filterGetParamDates, filterSetParamDates } from '@cobliteam/ui-business/components/DataTable';
import { filterGetCustomParams, filterSetCustomParams } from '@cobliteam/ui-business/components/DataTable/components/Filters/FiltersParams';
import queryString from 'query-string';
import type { StateCreator } from 'zustand';
import type { AlertsSlices } from '.';

interface TriggerEventsSliceState {
  dateRange: DateRangeFns;
  vehicleId?: string;
  date?: string;
  setDateRange: (dateRange: DateRangeFns) => void;
  setVehicleDateParams: (vehicleId?: string, date?: string) => void;
  triggerEvent: TriggerEvent | null;
  setTriggerEvent: (triggerEvent: TriggerEvent | null) => void;
  showEditObservations: boolean;
  showDeleteObservations: boolean;
  setShowEditObservations: (show: boolean) => void;
  setShowDeleteObservations: (show: boolean) => void;
}

type StateCreatorTriggerEvents = StateCreator<AlertsSlices, [['zustand/devtools', never]], [], TriggerEventsSliceState>;

const createTriggerEventsSlice: StateCreatorTriggerEvents = (set) => {
  // default to yesterday
  const dateRange = filterGetParamDates(1, 1);
  const { startDate, endDate } = queryString.parse(window.location.search);

  return {
    dateRange: dateRange || {
      startDate: startDate ? new Date(startDate as string) : new Date(),
      endDate: endDate ? new Date(endDate as string) : new Date(),
    },
    vehicleId: filterGetCustomParams('vehicle_id'),
    date: filterGetCustomParams('date'),
    setDateRange: (dateRange: DateRangeFns) => {
      filterSetParamDates(dateRange);
      set({ dateRange });
    },
    setVehicleDateParams: (vehicleId?: string, date?: string) => {
      filterSetCustomParams('vehicle_id', vehicleId);
      filterSetCustomParams('date', date);
      set({ vehicleId, date });
    },
    showEditObservations: false,
    showDeleteObservations: false,
    setShowEditObservations: (show: boolean) => {
      set({ showEditObservations: show });
    },
    setShowDeleteObservations: (show: boolean) => {
      set({ showDeleteObservations: show });
    },
    triggerEvent: null,
    setTriggerEvent: (triggerEvent: TriggerEvent | null) => {
      set({ triggerEvent });
    },
  };
};

export type { TriggerEventsSliceState };
export default createTriggerEventsSlice;
